import * as React from 'react';

function SvgEyeHidden(props) {
  return (
    <svg width={25} height={25} viewBox="0 0 20 20" fill="none" {...props}>
      <path
        d="M16.833 8.212a8.68 8.68 0 011.382 2.21v.241a8.536 8.536 0 01-1.38 2.2 8.96 8.96 0 01-1.963 1.696 9.15 9.15 0 01-2.333 1.056A8.95 8.95 0 0110 15.98a8.95 8.95 0 01-2.54-.365 9.15 9.15 0 01-2.332-1.056 8.961 8.961 0 01-1.963-1.696 8.874 8.874 0 01-1.38-2.164v-.313a8.898 8.898 0 011.389-2.172 9.229 9.229 0 011.975-1.716 9.04 9.04 0 017.425-1.063 8.693 8.693 0 012.308 1.06 9.242 9.242 0 011.95 1.717z"
        stroke={props.color}
        strokeWidth={1.5}
        fill="none"
      />
      <path
        d="M10.053 13.918c.937 0 1.734-.329 2.39-.985.657-.656.985-1.453.985-2.39 0-.926-.328-1.72-.985-2.382a3.24 3.24 0 00-2.39-.993c-.926 0-1.72.33-2.382.993-.662.662-.993 1.456-.993 2.382 0 .937.33 1.734.993 2.39a3.263 3.263 0 002.382.985z"
        fill={props.color}
        stroke={props.color}
        strokeWidth={0.5}
      />
      <path
        d="M10.053 12.793c-.61 0-1.14-.223-1.591-.668a2.168 2.168 0 01-.677-1.6c0-.621.22-1.151.66-1.59.439-.44.97-.66 1.59-.66.621 0 1.152.22 1.591.66.44.439.66.969.66 1.59 0 .621-.218 1.154-.651 1.6a2.125 2.125 0 01-1.582.668z"
        fill="#fff"
      />
      <path
        stroke={props.color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M17.5 3.061L2.561 18"
      />
    </svg>
  );
}

export default SvgEyeHidden;
